import http from '@/config/axios';
import type { AxiosResponse } from 'axios';
import type { ApiResponse } from '@/types/api';
import type { AdminLoginRequest, AdminLoginData, Admin } from '@/types/admin';

/**
 * 管理员登录
 */
export async function login(data: AdminLoginRequest): Promise<AxiosResponse<ApiResponse<AdminLoginData>>> {
  return http.post('/login', data);
}

/**
 * 获取当前管理员个人信息
 */
export async function getProfile(): Promise<AxiosResponse<ApiResponse<Admin>>> {
  return http.get('/profile');
}

/**
 * 管理员登出
 * 注意：后端是无状态的，前端只需清除本地存储即可，但为了保持接口一致性，仍调用后端接口
 */
export async function logout(): Promise<AxiosResponse<ApiResponse<null>>> {
  return http.post('/logout');
}